import { render, staticRenderFns } from "./Jbfcmall.vue?vue&type=template&id=e2ddf63c&scoped=true"
import script from "./Jbfcmall.vue?vue&type=script&lang=js"
export * from "./Jbfcmall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2ddf63c",
  null
  
)

export default component.exports